module.exports = __webpack_public_path__ + "static/assets/2b447af1d66689f83ea901f92e3ca9ad.svg";